/* =============================================================================
   KEX motion engine v2
   Reveal bidireccional (baja y sube), tipografia cinetica, scrub por scroll,
   parallax por capas, marquesinas, tilt, magnetismo, contadores, tabs y rieles.
   Sin dependencias. Respeta prefers-reduced-motion.
   ============================================================================= */
(function () {
  'use strict';

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var COARSE = window.matchMedia('(hover: none)').matches;
  if (REDUCE) document.documentElement.classList.add('kx-reduce');

  function each(sel, root, fn) {
    var list = (root || document).querySelectorAll(sel);
    for (var i = 0; i < list.length; i++) fn(list[i], i);
  }
  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }

  /* ---------------------------------------------------------------------------
     1. Reveal bidireccional
     Entra al bajar y al subir; al salir se desvanece hacia el lado por el que sale.
  --------------------------------------------------------------------------- */
  var revealItems = [];

  function applyDirection(el, fromBelow) {
    var mode = el.getAttribute('data-kx-reveal') || 'up';
    var d = fromBelow ? 1 : -1;
    if (mode === 'left')      { el.style.setProperty('--kx-fx', (30 * d) + 'px'); el.style.setProperty('--kx-fy', '0px'); }
    else if (mode === 'right'){ el.style.setProperty('--kx-fx', (-30 * d) + 'px'); el.style.setProperty('--kx-fy', '0px'); }
    else if (mode === 'grow') { el.style.setProperty('--kx-fy', (26 * d) + 'px'); el.style.setProperty('--kx-fs', '.92'); }
    else if (mode === 'zoom') { el.style.setProperty('--kx-fy', (18 * d) + 'px'); el.style.setProperty('--kx-fs', '.94'); }
    else if (mode === 'blur') { el.style.setProperty('--kx-fy', (22 * d) + 'px'); el.style.setProperty('--kx-fb', '12px'); }
    else                      { el.style.setProperty('--kx-fy', (32 * d) + 'px'); }
  }

  function initReveal(root) {
    if (REDUCE) { each('[data-kx-reveal]', root, function (el) { el.classList.add('is-in'); el.classList.add('kx-split-in'); }); return; }
    each('[data-kx-reveal]', root, function (el) {
      if (el.dataset.kxRevealBound) return;
      el.dataset.kxRevealBound = '1';
      applyDirection(el, true);
      var group = el.closest('[data-kx-stagger]');
      if (group && !el.style.getPropertyValue('--kx-delay')) {
        var step = parseInt(group.getAttribute('data-kx-stagger'), 10) || 70;
        var sibs = group.querySelectorAll('[data-kx-reveal]');
        var idx = Array.prototype.indexOf.call(sibs, el);
        el.style.setProperty('--kx-delay', Math.min(idx, 14) * step + 'ms');
      }
      revealItems.push(el);
    });
  }

  function measureReveal(vh) {
    var changes = [];
    for (var i = 0; i < revealItems.length; i++) {
      var el = revealItems[i];
      if (!el.isConnected) continue;
      var r = el.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) continue;
      var inView = r.top < vh * 0.94 && r.bottom > vh * 0.05;
      var isIn = el.classList.contains('is-in');
      if (inView === isIn) continue;
      changes.push({ el: el, inView: inView, fromBelow: r.top > vh * 0.5 });
    }
    return changes;
  }

  function applyReveal(changes) {
    for (var i = 0; i < changes.length; i++) {
      var change = changes[i], el = change.el;
      applyDirection(el, change.fromBelow);
      el.classList.toggle('is-in', change.inView);
      if (el.hasAttribute('data-kx-split')) el.classList.toggle('kx-split-in', change.inView);
    }
  }

  /* ---------------------------------------------------------------------------
     2. Tipografia cinetica: parte el texto en palabras
  --------------------------------------------------------------------------- */
  function initSplit(root) {
    each('[data-kx-split]', root, function (el) {
      if (el.dataset.kxSplitBound) return;
      el.dataset.kxSplitBound = '1';
      var target = el.querySelector('p') || el;
      var walker = document.createTreeWalker(target, NodeFilter.SHOW_TEXT, null);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      var n = 0;
      nodes.forEach(function (node) {
        if (!node.nodeValue.trim()) return;
        var frag = document.createDocumentFragment();
        node.nodeValue.split(/(\s+)/).forEach(function (chunk) {
          if (!chunk.trim()) { frag.appendChild(document.createTextNode(chunk)); return; }
          var outer = document.createElement('span');
          outer.className = 'kx-w';
          var inner = document.createElement('span');
          inner.className = 'kx-w__i';
          inner.textContent = chunk;
          inner.style.transitionDelay = Math.min(n, 24) * 42 + 'ms';
          n++;
          outer.appendChild(inner);
          frag.appendChild(outer);
        });
        node.parentNode.replaceChild(frag, node);
      });
    });
  }

  /* ---------------------------------------------------------------------------
     3. Parallax por capas + scrub de progreso
  --------------------------------------------------------------------------- */
  var pxItems = [], scrubItems = [], ticking = false;

  function collectMotion(root) {
    each('[data-kx-parallax]', root, function (el) {
      if (el.dataset.kxPxBound) return;
      el.dataset.kxPxBound = '1';
      pxItems.push({ el: el, k: parseFloat(el.getAttribute('data-kx-parallax')) || 0.12 });
    });
    each('[data-kx-scrub]', root, function (el) {
      if (el.dataset.kxScrubBound) return;
      el.dataset.kxScrubBound = '1';
      scrubItems.push(el);
    });
  }

  function frame() {
    ticking = false;
    var vh = window.innerHeight;
    // Read every position before changing styles/classes. Interleaving them
    // forces repeated synchronous layouts when several reveals enter together.
    var reveals = REDUCE ? [] : measureReveal(vh);
    var parallax = [], scrubs = [];
    if (!REDUCE) {
      for (var i = 0; i < pxItems.length; i++) {
        if (!pxItems[i].el.isConnected) continue;
        var it = pxItems[i], r = it.el.getBoundingClientRect();
        if (r.bottom < -240 || r.top > vh + 240) continue;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        parallax.push({ el: it.el, transform: 'translate3d(0,' + (p * it.k * -100).toFixed(2) + 'px,0)' });
      }
    }
    for (var j = 0; j < scrubItems.length; j++) {
      if (!scrubItems[j].isConnected) continue;
      var el = scrubItems[j], rr = el.getBoundingClientRect();
      var prog = clamp((vh - rr.top) / (vh + rr.height), 0, 1);
      scrubs.push({ el: el, progress: prog.toFixed(4) });
    }
    var y = window.scrollY || 0;
    applyReveal(reveals);
    for (var k = 0; k < parallax.length; k++) {
      var px = parallax[k];
      if (px.el.style.transform !== px.transform) px.el.style.transform = px.transform;
    }
    for (var s = 0; s < scrubs.length; s++) {
      var scrub = scrubs[s];
      if (scrub.el.style.getPropertyValue('--kx-p') !== scrub.progress) scrub.el.style.setProperty('--kx-p', scrub.progress);
    }
    document.documentElement.classList.toggle('kx-scrolled', y > 40);
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  setInterval(function(){ if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, 400);

  /* ---------------------------------------------------------------------------
     4. Marquesinas infinitas
  --------------------------------------------------------------------------- */
  function initMarquee(root) {
    each('[data-kx-marquee]', root, function (el) {
      var track = el.querySelector('.kx-marquee__track');
      if (!track) return;
      if (!el.dataset.kxMarqueeBound) {
        el.dataset.kxMarqueeBound = '1';
        var clone = track.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        each('a, button, input, select, textarea, [tabindex]', clone, function (focusable) {
          focusable.setAttribute('tabindex', '-1');
        });
        el.appendChild(clone);
      }
      var speed = parseFloat(el.getAttribute('data-kx-marquee')) || 40;
      var w = track.scrollWidth || 1;
      var dur = Math.max(8, w / speed);
      var tracks = el.querySelectorAll('.kx-marquee__track');
      tracks.forEach(function (t) { t.style.animationName = 'none'; });
      void el.offsetWidth;
      tracks.forEach(function (t) {
        t.style.animationDuration = dur + 's';
        t.style.animationName = '';
      });
    });
  }

  /* ---------------------------------------------------------------------------
     5. Tilt 3D y brillo que sigue al cursor
  --------------------------------------------------------------------------- */
  function initPointer(root) {
    if (REDUCE || COARSE) return;
    each('[data-kx-tilt]', root, function (el) {
      if (el.dataset.kxTiltBound) return;
      el.dataset.kxTiltBound = '1';
      var max = parseFloat(el.getAttribute('data-kx-tilt')) || 6;
      el.addEventListener('pointermove', function (ev) {
        var r = el.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width - 0.5;
        var py = (ev.clientY - r.top) / r.height - 0.5;
        el.style.setProperty('--kx-rx', (-py * max).toFixed(2) + 'deg');
        el.style.setProperty('--kx-ry', (px * max).toFixed(2) + 'deg');
        el.classList.add('is-tilting');
      });
      el.addEventListener('pointerleave', function () {
        el.style.setProperty('--kx-rx', '0deg');
        el.style.setProperty('--kx-ry', '0deg');
        el.classList.remove('is-tilting');
      });
    });
    each('[data-kx-glow]', root, function (el) {
      if (el.dataset.kxGlowBound) return;
      el.dataset.kxGlowBound = '1';
      el.addEventListener('pointermove', function (ev) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--kx-mx', (((ev.clientX - r.left) / r.width) * 100).toFixed(1) + '%');
        el.style.setProperty('--kx-my', (((ev.clientY - r.top) / r.height) * 100).toFixed(1) + '%');
      });
    });
    each('[data-kx-magnet]', root, function (el) {
      if (el.dataset.kxMagnetBound) return;
      el.dataset.kxMagnetBound = '1';
      var s = parseFloat(el.getAttribute('data-kx-magnet')) || 0.28;
      el.addEventListener('pointermove', function (ev) {
        var r = el.getBoundingClientRect();
        el.style.transform = 'translate3d(' + ((ev.clientX - r.left - r.width / 2) * s).toFixed(1) + 'px,' + ((ev.clientY - r.top - r.height / 2) * s).toFixed(1) + 'px,0)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------------------------------------------------------------------------
     6. Contadores
  --------------------------------------------------------------------------- */
  function initCounters(root) {
    each('[data-kx-count]', root, function (el) {
      if (el.dataset.kxCountBound) return;
      el.dataset.kxCountBound = '1';
      var target = parseFloat(el.getAttribute('data-kx-count')) || 0;
      var suffix = el.getAttribute('data-kx-count-suffix') || '';
      var prefix = el.getAttribute('data-kx-count-prefix') || '';
      var fmt = function (v) { return prefix + (target % 1 === 0 ? Math.round(v).toLocaleString('es-MX') : v.toFixed(1)) + suffix; };
      if (REDUCE || !('IntersectionObserver' in window)) { el.textContent = fmt(target); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.disconnect();
          var start = performance.now(), dur = 1500;
          (function step(now) {
            var p = Math.min(1, (now - start) / dur);
            el.textContent = fmt(target * (1 - Math.pow(1 - p, 3)));
            if (p < 1) requestAnimationFrame(step);
          })(performance.now());
        });
      }, { threshold: 0.35 });
      io.observe(el);
    });
  }

  /* ---------------------------------------------------------------------------
     7. Pestanas accesibles
  --------------------------------------------------------------------------- */
  function initTabs(root) {
    each('[data-kx-tabs]', root, function (wrap) {
      if (wrap.dataset.kxTabsBound) return;
      wrap.dataset.kxTabsBound = '1';
      var btns = wrap.querySelectorAll('[data-kx-tab-btn]');
      var panels = wrap.querySelectorAll('[data-kx-tab-panel]');
      var ink = wrap.querySelector('[data-kx-tab-ink]');
      function moveInk(btn) {
        if (!ink || !btn) return;
        ink.style.width = btn.offsetWidth + 'px';
        ink.style.transform = 'translate3d(' + btn.offsetLeft + 'px,0,0)';
      }
      function activate(id) {
        var active = null;
        for (var i = 0; i < btns.length; i++) {
          var on = btns[i].getAttribute('data-kx-tab-btn') === id;
          btns[i].classList.toggle('is-active', on);
          btns[i].setAttribute('aria-selected', on ? 'true' : 'false');
          btns[i].setAttribute('tabindex', on ? '0' : '-1');
          if (on) active = btns[i];
        }
        for (var j = 0; j < panels.length; j++) {
          var show = panels[j].getAttribute('data-kx-tab-panel') === id;
          panels[j].hidden = !show;
          if (show) { panels[j].classList.remove('is-in'); void panels[j].offsetWidth; panels[j].classList.add('is-in'); }
        }
        moveInk(active);
      }
      for (var i = 0; i < btns.length; i++) {
        (function (btn) {
          btn.addEventListener('click', function () { activate(btn.getAttribute('data-kx-tab-btn')); });
          btn.addEventListener('keydown', function (ev) {
            var idx = Array.prototype.indexOf.call(btns, btn), next = null;
            if (ev.key === 'ArrowRight') next = btns[(idx + 1) % btns.length];
            if (ev.key === 'ArrowLeft') next = btns[(idx - 1 + btns.length) % btns.length];
            if (next) { ev.preventDefault(); next.focus(); next.click(); }
          });
        })(btns[i]);
      }
      var first = wrap.querySelector('[data-kx-tab-btn].is-active') || btns[0];
      if (first) requestAnimationFrame(function () { moveInk(first); });
      window.addEventListener('resize', function () { moveInk(wrap.querySelector('[data-kx-tab-btn].is-active')); });
    });
  }

  /* ---------------------------------------------------------------------------
     8. Rieles con arrastre, barra de progreso y flechas
  --------------------------------------------------------------------------- */
  function initScrollers(root) {
    each('[data-kx-scroller]', root, function (wrap) {
      if (wrap.dataset.kxScrollerBound) return;
      wrap.dataset.kxScrollerBound = '1';
      var rail = wrap.querySelector('[data-kx-rail]');
      if (!rail) return;
      var prev = wrap.querySelector('[data-kx-prev]');
      var next = wrap.querySelector('[data-kx-next]');
      var bar = wrap.querySelector('[data-kx-progress]');

      function step() {
        var first = rail.firstElementChild;
        return first ? first.getBoundingClientRect().width + 20 : rail.clientWidth * 0.8;
      }
      function update() {
        var max = rail.scrollWidth - rail.clientWidth;
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max - 2;
        if (bar) bar.style.setProperty('--kx-p', max > 0 ? (rail.scrollLeft / max).toFixed(4) : '0');
        wrap.classList.toggle('is-scrollable', rail.scrollWidth > rail.clientWidth + 4);
      }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: REDUCE ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: REDUCE ? 'auto' : 'smooth' }); });
      rail.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);

      if (!COARSE) {
        var down = false, sx = 0, sl = 0, moved = false;
        rail.addEventListener('pointerdown', function (e) {
          if (e.button !== 0) return;
          down = true; moved = false; sx = e.clientX; sl = rail.scrollLeft;
          rail.classList.add('is-grabbing');
        });
        window.addEventListener('pointermove', function (e) {
          if (!down) return;
          var dx = e.clientX - sx;
          if (Math.abs(dx) > 4) moved = true;
          rail.scrollLeft = sl - dx;
        });
        window.addEventListener('pointerup', function () {
          if (!down) return;
          down = false;
          rail.classList.remove('is-grabbing');
          if (moved) { rail.addEventListener('click', function blocker(ev) { ev.preventDefault(); ev.stopPropagation(); rail.removeEventListener('click', blocker, true); }, true); }
        });
      }
      update();
    });
  }

  /* ---------------------------------------------------------------------------
     boot
  --------------------------------------------------------------------------- */
  function boot(root) {
    initSplit(root);
    initReveal(root);
    collectMotion(root);
    initMarquee(root);
    initPointer(root);
    initCounters(root);
    initTabs(root);
    initScrollers(root);
    frame();
  }
  window.KX = window.KX || {};
  window.KX.boot = boot;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { onScroll(); initMarquee(document); }, { passive: true });
  window.addEventListener('load', function () { initMarquee(document); frame(); });

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
